import React from 'react';
import PropTypes from 'prop-types';

const CommentItem = (props) => {
  return (
    <li>
      <div>
        {props.comment.user.displayName}
      </div>
      <div>
        <p>{props.comment.text}</p>
        <span>{props.comment.createdAt.toLocaleTimeString()}</span>
      </div>
    </li>
  );
}

CommentItem.propTypes = {
  comment: PropTypes.object.isRequired
};

export default CommentItem;


// WEBPACK FOOTER //
// ./src/views/commentItem.js